
export class StoreModel implements StoreModelProps {
  id: number;
  name: number;
  description: string;
  closed: boolean;
  image?: string;
  phone: string;
  email: string;
  country: string;
  state: string;

  constructor(data: StoreModelProps) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.closed = data.closed;
    this.image = data.image;
  }

  static empty() {
    return new StoreModel({
      id: null,
      name: null,
      description: null,
      closed: null,
      image: null,
      email: null,
      phone: null,
      country: null,
      state: null
    });
  }
}

export interface StoreModelProps {
  id: number;
  name: number;
  description: string;
  closed: boolean;
  image?: string;
  phone: string;
  email: string;
  country: string;
  state: string;
}

export interface StoreProfileModelProps {
  generalInfo: {
    storeUrl: string,
    websitePlatform?: string,
    profileId: string,
    starterSite: {
      ecwidSubdomain: string,
      generatedUrl: string,
      storeLogoUrl?: string
    }
  };
  account: {
    accountName: string,
    accountNickName: string,
    accountEmail: string,
    whiteLabel: boolean,
    suspended: boolean,
    itunesSubscriptionsAvailable: boolean,
    trackStorefrontStats: boolean,
    availableFeatures: any[],
    registrationDate: string
  };
  settings: {
    closed: boolean,
    storeName: string,
    storeDescriptionTranslated: any,
    googleRemarketingEnabled: boolean,
    orderCommentsEnabled: boolean,
    orderCommentsRequired: boolean,
    hideOutOfStockProductsInStorefront: boolean,
    askCompanyName: boolean,
    favoritesEnabled: boolean,
    defaultProductSortOrder: string,
    abandonedSales: any,
    salePrice: {
      displayOnProductList: boolean,
      displayDiscount: string
    };
    showAcceptMarketingCheckbox: boolean,
    acceptMarketingCheckboxDefaultValue: boolean,
    askConsentToTrackInStorefront: boolean,
    wixExternalTrackingEnabled: boolean,
    openBagOnAddition: boolean,
    requirePhoneOnCheckout: boolean,
    askZipCode: boolean,
    showPricePerUnit: boolean,
    askTaxId: boolean,
    productCondition: string,
    recurringSubscriptionsSettings: {
      showRecurringSubscriptionsInControlPanel: boolean,
      supportedPaymentMethodsStatuses: {
        supportedPaymentMethodsAreAvailable: boolean,
        supportedPaymentMethodsAreConnected: boolean
      }
    }
  };
  mailNotifications: any;
  company: {
    companyName: string,
    email: string,
    street: string,
    city: string,
    countryCode: string,
    postalCode: string,
    stateOrProvinceCode: string,
    phone: string
  };
  formatsAndUnits: {
    currency: string,
    currencyPrefix: string,
    currencySuffix: string,
    currencyGroupSeparator: string,
    currencyDecimalSeparator: string,
    currencyPrecision: number,
    currencyTruncateZeroFractional: boolean,
    currencyRate: number,
    weightUnit: string,
    weightGroupSeparator: string,
    weightDecimalSeparator: string,
    weightTruncateZeroFractional: boolean,
    timeFormat: string,
    dateFormat: string,
    timezone: string,
    dimensionsUnit: string,
    orderNumberPrefix: string,
    orderNumberSuffix: string,
    addressFormat: any
  };
  languages: any;
  shipping: any;
  zones: any[];
  taxes: any[];
  taxSettings: any;
  payment: any;
  featureToggles: any[];
  legalPagesSettings: any;
  designSettings: any;
  productFiltersSettings: any;
  orderInvoiceSettings: any;
  socialLinksSettings: any;
  tipsSettings: any;
  taxInvoiceSettings: any;
}

//Profile
export class StoreProfileModel implements StoreProfileModelProps {
generalInfo: {
  storeUrl: string,
  websitePlatform?: string,
  profileId: string,
  starterSite: {
    ecwidSubdomain: string,
    generatedUrl: string
    storeLogoUrl?: string
  }
};
account: {
  accountName: string,
  accountNickName: string,
  accountEmail: string,
  whiteLabel: boolean,
  suspended: boolean,
  itunesSubscriptionsAvailable: boolean,
  trackStorefrontStats: boolean,
  availableFeatures: any[],
  registrationDate: string
};
settings: {
  closed: boolean,
  storeName: string,
  storeDescriptionTranslated: any,
  googleRemarketingEnabled: boolean,
  orderCommentsEnabled: boolean,
  orderCommentsRequired: boolean,
  hideOutOfStockProductsInStorefront: boolean,
  askCompanyName: boolean,
  favoritesEnabled: boolean,
  defaultProductSortOrder: string,
  abandonedSales: any,
  salePrice: {
    displayOnProductList: boolean,
    displayDiscount: string
  };
  showAcceptMarketingCheckbox: boolean,
  acceptMarketingCheckboxDefaultValue: boolean,
  askConsentToTrackInStorefront: boolean,
  wixExternalTrackingEnabled: boolean,
  openBagOnAddition: boolean,
  requirePhoneOnCheckout: boolean,
  askZipCode: boolean,
  showPricePerUnit: boolean,
  askTaxId: boolean,
  productCondition: string,
  recurringSubscriptionsSettings: {
    showRecurringSubscriptionsInControlPanel: boolean,
    supportedPaymentMethodsStatuses: {
      supportedPaymentMethodsAreAvailable: boolean,
      supportedPaymentMethodsAreConnected: boolean
    }
  }
};
mailNotifications: any;
company: {
  companyName: string,
  email: string,
  street: string,
  city: string,
  countryCode: string,
  postalCode: string,
  stateOrProvinceCode: string,
  phone: string
};
formatsAndUnits: {
  currency: string,
  currencyPrefix: string,
  currencySuffix: string,
  currencyGroupSeparator: string,
  currencyDecimalSeparator: string,
  currencyPrecision: number,
  currencyTruncateZeroFractional: boolean,
  currencyRate: number,
  weightUnit: string,
  weightGroupSeparator: string,
  weightDecimalSeparator: string,
  weightTruncateZeroFractional: boolean,
  timeFormat: string,
  dateFormat: string,
  timezone: string,
  dimensionsUnit: string,
  orderNumberPrefix: string,
  orderNumberSuffix: string,
  addressFormat: any
};
languages: any;
shipping: any;
zones: any[];
taxes: any[];
taxSettings: any;
payment: any;
featureToggles: any[];
legalPagesSettings: any;
designSettings: any;
productFiltersSettings: any;
orderInvoiceSettings: any;
socialLinksSettings: any;
tipsSettings: any;
taxInvoiceSettings: any;


  constructor(data: StoreProfileModelProps) {
    this.generalInfo = {
      storeUrl: data.generalInfo.storeUrl,
      websitePlatform: data.generalInfo.websitePlatform,
      profileId: data.generalInfo.profileId,
      starterSite: {
        ecwidSubdomain: data.generalInfo.starterSite.ecwidSubdomain,
        generatedUrl: data.generalInfo.starterSite.generatedUrl,
        storeLogoUrl: data.generalInfo.starterSite.storeLogoUrl
      }
    },
    this.account = {
      accountName: data.account.accountName,
      accountNickName: data.account.accountNickName,
      accountEmail: data.account.accountEmail,
      whiteLabel: data.account.whiteLabel,
      suspended: data.account.suspended,
      itunesSubscriptionsAvailable: data.account.itunesSubscriptionsAvailable,
      trackStorefrontStats: data.account.trackStorefrontStats,
      availableFeatures: data.account.availableFeatures,
      registrationDate: data.account.registrationDate
    },
    this.settings = {
      closed: data.settings.closed,
      storeName: data.settings.storeName,
      storeDescriptionTranslated: data.settings.storeDescriptionTranslated,
      googleRemarketingEnabled: data.settings.googleRemarketingEnabled,
      orderCommentsEnabled: data.settings.orderCommentsEnabled,
      orderCommentsRequired: data.settings.orderCommentsRequired,
      hideOutOfStockProductsInStorefront: data.settings.hideOutOfStockProductsInStorefront,
      askCompanyName: data.settings.askCompanyName,
      favoritesEnabled: data.settings.favoritesEnabled,
      defaultProductSortOrder: data.settings.defaultProductSortOrder,
      abandonedSales: data.settings.abandonedSales,
      salePrice: {
        displayOnProductList: data.settings.salePrice.displayOnProductList,
        displayDiscount: data.settings.salePrice.displayDiscount
      },
      showAcceptMarketingCheckbox: data.settings.showAcceptMarketingCheckbox,
      acceptMarketingCheckboxDefaultValue: data.settings.acceptMarketingCheckboxDefaultValue,
      askConsentToTrackInStorefront: data.settings.askConsentToTrackInStorefront,
      wixExternalTrackingEnabled: data.settings.wixExternalTrackingEnabled,
      openBagOnAddition: data.settings.openBagOnAddition,
      requirePhoneOnCheckout: data.settings.requirePhoneOnCheckout,
      askZipCode: data.settings.askZipCode,
      showPricePerUnit: data.settings.showPricePerUnit,
      askTaxId: data.settings.askTaxId,
      productCondition: data.settings.productCondition,
      recurringSubscriptionsSettings: {
        showRecurringSubscriptionsInControlPanel: data.settings.recurringSubscriptionsSettings.showRecurringSubscriptionsInControlPanel,
        supportedPaymentMethodsStatuses: {
          supportedPaymentMethodsAreAvailable: data.settings.recurringSubscriptionsSettings.supportedPaymentMethodsStatuses.supportedPaymentMethodsAreAvailable,
          supportedPaymentMethodsAreConnected: data.settings.recurringSubscriptionsSettings.supportedPaymentMethodsStatuses.supportedPaymentMethodsAreConnected
        }
      }
    },
    this.mailNotifications = data.mailNotifications,
    this.company = {
      companyName: null,
      email: null,
      street: null,
      city: null,
      countryCode: null,
      postalCode: null,
      stateOrProvinceCode: null,
      phone: null
    },
    this.formatsAndUnits = {
      currency: data.formatsAndUnits.currency,
      currencyPrefix: data.formatsAndUnits.currencyPrefix,
      currencySuffix: data.formatsAndUnits.currencySuffix,
      currencyGroupSeparator: data.formatsAndUnits.currencyGroupSeparator,
      currencyDecimalSeparator: data.formatsAndUnits.currencyDecimalSeparator,
      currencyPrecision: data.formatsAndUnits.currencyPrecision,
      currencyTruncateZeroFractional: data.formatsAndUnits.currencyTruncateZeroFractional,
      currencyRate: data.formatsAndUnits.currencyRate,
      weightUnit: data.formatsAndUnits.weightUnit,
      weightGroupSeparator: data.formatsAndUnits.weightGroupSeparator,
      weightDecimalSeparator: data.formatsAndUnits.weightDecimalSeparator,
      weightTruncateZeroFractional: data.formatsAndUnits.weightTruncateZeroFractional,
      timeFormat: data.formatsAndUnits.timeFormat,
      dateFormat: data.formatsAndUnits.dateFormat,
      timezone: data.formatsAndUnits.timezone,
      dimensionsUnit: data.formatsAndUnits.dimensionsUnit,
      orderNumberPrefix: data.formatsAndUnits.orderNumberPrefix,
      orderNumberSuffix: data.formatsAndUnits.orderNumberSuffix,
      addressFormat: data.formatsAndUnits.addressFormat
    },
    this.languages = data.languages,
    this.shipping = data.shipping,
    this.zones = data.zones,
    this.taxes = data.taxes,
    this.taxSettings = data.taxSettings,
    this.payment = data.payment,
    this.featureToggles = data.featureToggles,
    this.legalPagesSettings = data.legalPagesSettings,
    this.designSettings = data.designSettings,
    this.productFiltersSettings = data.productFiltersSettings,
    this.orderInvoiceSettings = data.orderInvoiceSettings,
    this.socialLinksSettings = data.socialLinksSettings,
    this.tipsSettings = data.tipsSettings,
    this.taxInvoiceSettings = data.taxInvoiceSettings
  }


  static fromApi(data: StoreProfileModel) {
    return ({
      generalInfo: {
        storeUrl: data.generalInfo.storeUrl,
        websitePlatform: data.generalInfo.websitePlatform,
        profileId: data.generalInfo.profileId,
        starterSite: {
          ecwidSubdomain: data.generalInfo.starterSite.ecwidSubdomain,
          generatedUrl: data.generalInfo.starterSite.generatedUrl,
          storeLogoUrl: data.generalInfo.starterSite.storeLogoUrl
        }
      },
      account: {
        accountName: data.account.accountName,
        accountNickName: data.account.accountNickName,
        accountEmail: data.account.accountEmail,
        whiteLabel: data.account.whiteLabel,
        suspended: data.account.suspended,
        itunesSubscriptionsAvailable: data.account.itunesSubscriptionsAvailable,
        trackStorefrontStats: data.account.trackStorefrontStats,
        availableFeatures: data.account.availableFeatures,
        registrationDate: data.account.registrationDate
      },
      settings: {
        closed: data.settings.closed,
        storeName: data.settings.storeName,
        storeDescriptionTranslated: data.settings.storeDescriptionTranslated,
        googleRemarketingEnabled: data.settings.googleRemarketingEnabled,
        orderCommentsEnabled: data.settings.orderCommentsEnabled,
        orderCommentsRequired: data.settings.orderCommentsRequired,
        hideOutOfStockProductsInStorefront: data.settings.hideOutOfStockProductsInStorefront,
        askCompanyName: data.settings.askCompanyName,
        favoritesEnabled: data.settings.favoritesEnabled,
        defaultProductSortOrder: data.settings.defaultProductSortOrder,
        abandonedSales: data.settings.abandonedSales,
        salePrice: {
          displayOnProductList: data.settings.salePrice.displayOnProductList,
          displayDiscount: data.settings.salePrice.displayDiscount
        },
        showAcceptMarketingCheckbox: data.settings.showAcceptMarketingCheckbox,
        acceptMarketingCheckboxDefaultValue: data.settings.acceptMarketingCheckboxDefaultValue,
        askConsentToTrackInStorefront: data.settings.askConsentToTrackInStorefront,
        wixExternalTrackingEnabled: data.settings.wixExternalTrackingEnabled,
        openBagOnAddition: data.settings.openBagOnAddition,
        requirePhoneOnCheckout: data.settings.requirePhoneOnCheckout,
        askZipCode: data.settings.askZipCode,
        showPricePerUnit: data.settings.showPricePerUnit,
        askTaxId: data.settings.askTaxId,
        productCondition: data.settings.productCondition,
        recurringSubscriptionsSettings: {
          showRecurringSubscriptionsInControlPanel: data.settings.recurringSubscriptionsSettings.showRecurringSubscriptionsInControlPanel,
          supportedPaymentMethodsStatuses: {
            supportedPaymentMethodsAreAvailable: data.settings.recurringSubscriptionsSettings.supportedPaymentMethodsStatuses.supportedPaymentMethodsAreAvailable,
            supportedPaymentMethodsAreConnected: data.settings.recurringSubscriptionsSettings.supportedPaymentMethodsStatuses.supportedPaymentMethodsAreConnected
          }
        }
      },
      mailNotifications: data.mailNotifications,
      company: {
        companyName: data.company.companyName,
        email: data.company.email,
        street: data.company.street,
        city: data.company.city,
        countryCode: data.company.countryCode,
        postalCode: data.company.postalCode,
        stateOrProvinceCode: data.company.stateOrProvinceCode,
        phone: data.company.phone
      },
      formatsAndUnits: {
        currency: data.formatsAndUnits.currency,
        currencyPrefix: data.formatsAndUnits.currencyPrefix,
        currencySuffix: data.formatsAndUnits.currencySuffix,
        currencyGroupSeparator: data.formatsAndUnits.currencyGroupSeparator,
        currencyDecimalSeparator: data.formatsAndUnits.currencyDecimalSeparator,
        currencyPrecision: data.formatsAndUnits.currencyPrecision,
        currencyTruncateZeroFractional: data.formatsAndUnits.currencyTruncateZeroFractional,
        currencyRate: data.formatsAndUnits.currencyRate,
        weightUnit: data.formatsAndUnits.weightUnit,
        weightGroupSeparator: data.formatsAndUnits.weightGroupSeparator,
        weightDecimalSeparator: data.formatsAndUnits.weightDecimalSeparator,
        weightTruncateZeroFractional: data.formatsAndUnits.weightTruncateZeroFractional,
        timeFormat: data.formatsAndUnits.timeFormat,
        dateFormat: data.formatsAndUnits.dateFormat,
        timezone: data.formatsAndUnits.timezone,
        dimensionsUnit: data.formatsAndUnits.dimensionsUnit,
        orderNumberPrefix: data.formatsAndUnits.orderNumberPrefix,
        orderNumberSuffix: data.formatsAndUnits.orderNumberSuffix,
        addressFormat: data.formatsAndUnits.addressFormat
      },
      languages: data.languages,
      shipping: data.shipping,
      zones: data.zones,
      taxes: data.taxes,
      taxSettings: data.taxSettings,
      payment: data.payment,
      featureToggles: data.featureToggles,
      legalPagesSettings: data.legalPagesSettings,
      designSettings: data.designSettings,
      productFiltersSettings: data.productFiltersSettings,
      orderInvoiceSettings: data.orderInvoiceSettings,
      socialLinksSettings: data.socialLinksSettings,
      tipsSettings: data.tipsSettings,
      taxInvoiceSettings: data.taxInvoiceSettings
    });
  }


  static empty() {
    return new StoreProfileModel({
      generalInfo: {
        storeUrl: null,
        websitePlatform: null,
        profileId: null,
        starterSite: {
          ecwidSubdomain: null,
          generatedUrl: null,
          storeLogoUrl: null
        }
      },
      account: {
        accountName: null,
        accountNickName: null,
        accountEmail: null,
        whiteLabel: null,
        suspended: null,
        itunesSubscriptionsAvailable: null,
        trackStorefrontStats: null,
        availableFeatures: null,
        registrationDate: null
      },
      settings: {
        closed: null,
        storeName: null,
        storeDescriptionTranslated: null,
        googleRemarketingEnabled: null,
        orderCommentsEnabled: null,
        orderCommentsRequired: null,
        hideOutOfStockProductsInStorefront: null,
        askCompanyName: null,
        favoritesEnabled: null,
        defaultProductSortOrder: null,
        abandonedSales: null,
        salePrice: {
          displayOnProductList: null,
          displayDiscount: null
        },
        showAcceptMarketingCheckbox: null,
        acceptMarketingCheckboxDefaultValue: null,
        askConsentToTrackInStorefront: null,
        wixExternalTrackingEnabled: null,
        openBagOnAddition: null,
        requirePhoneOnCheckout: null,
        askZipCode: null,
        showPricePerUnit: null,
        askTaxId: null,
        productCondition: null,
        recurringSubscriptionsSettings: {
          showRecurringSubscriptionsInControlPanel: null,
          supportedPaymentMethodsStatuses: {
            supportedPaymentMethodsAreAvailable: null,
            supportedPaymentMethodsAreConnected: null
          }
        }
      },
      mailNotifications: null,
      company: {
        companyName: null,
        email: null,
        street: null,
        city: null,
        countryCode: null,
        postalCode: null,
        stateOrProvinceCode: null,
        phone: null
      },
      formatsAndUnits: {
        currency: null,
        currencyPrefix: null,
        currencySuffix: null,
        currencyGroupSeparator: null,
        currencyDecimalSeparator: null,
        currencyPrecision: null,
        currencyTruncateZeroFractional: null,
        currencyRate: null,
        weightUnit: null,
        weightGroupSeparator: null,
        weightDecimalSeparator: null,
        weightTruncateZeroFractional: null,
        timeFormat: null,
        dateFormat: null,
        timezone: null,
        dimensionsUnit: null,
        orderNumberPrefix: null,
        orderNumberSuffix: null,
        addressFormat: null
      },
      languages: null,
      shipping: null,
      zones: null,
      taxes: null,
      taxSettings: null,
      payment: null,
      featureToggles: null,
      legalPagesSettings: null,
      designSettings: null,
      productFiltersSettings: null,
      orderInvoiceSettings: null,
      socialLinksSettings: null,
      tipsSettings: null,
      taxInvoiceSettings: null,      
    });
  }
}

export interface StatesModelProps {
  code: string;
  name: string;
}


export interface IUpdateProfileStorePayload {

  // settings: {
  //   closed: boolean,
  //   storeName: string;
  //   storeDescription: string;
  //   googleRemarketingEnabled?: boolean,
  //   hideOutOfStockProductsInStorefront: boolean,
  //   askCompanyName: boolean,
  //   favoritesEnabled?: boolean,
  //   abandonedSales?: {
  //     autoAbandonedSalesRecovery: boolean
  //   }
  // };
  // company: {
  //   companyName?: string;
  //   email?: string;
  //   street?: string;
  //   city?: string;
  //   countryCode?: string;
  //   postalCode?: string;
  //   stateOrProvinceCode?: string;
  //   phone?: string;
  // };

  generalInfo: {
    storeUrl: string
  },
  settings: {
    closed: boolean,
    storeName: string,
    storeDescriptionTranslated: any,
    googleRemarketingEnabled: boolean,
    hideOutOfStockProductsInStorefront: boolean,
    askCompanyName: boolean,
    favoritesEnabled: boolean,
    abandonedSales: any,
    salePrice: any;
    showAcceptMarketingCheckbox: boolean,
    acceptMarketingCheckboxDefaultValue: boolean,
    askConsentToTrackInStorefront: boolean,
    //"acceptMarketingCheckboxCustomText": "I accept to receive marketing offers to my email",
    //"pinterestTagId": "1251515431215"
  },
  company: {
    companyName: string,
    email: string,
    street: string,
    city: string,
    countryCode: string,
    postalCode: string,
    stateOrProvinceCode: string,
    phone: string
  };
  legalPagesSettings: any;
  designSettings: any;







  // generalInfo: {
  //   storeUrl: string,
  //   websitePlatform?: string,
  //   profileId: string,
  //   starterSite: {
  //     ecwidSubdomain: string,
  //     generatedUrl: string
  //   }
  // };
  // account: {
  //   accountName: string,
  //   accountNickName: string,
  //   accountEmail: string,
  //   whiteLabel: boolean,
  //   suspended: boolean,
  //   itunesSubscriptionsAvailable: boolean,
  //   trackStorefrontStats: boolean,
  //   availableFeatures: any[],
  //   registrationDate: string
  // };
  // settings: {
  //   closed: boolean,
  //   storeName: string,
  //   storeDescriptionTranslated: any,
  //   googleRemarketingEnabled: boolean,
  //   orderCommentsEnabled: boolean,
  //   orderCommentsRequired: boolean,
  //   hideOutOfStockProductsInStorefront: boolean,
  //   askCompanyName: boolean,
  //   favoritesEnabled: boolean,
  //   defaultProductSortOrder: string,
  //   abandonedSales: any,
  //   salePrice: {
  //     displayOnProductList: boolean,
  //     displayDiscount: string
  //   };
  //   showAcceptMarketingCheckbox: boolean,
  //   acceptMarketingCheckboxDefaultValue: boolean,
  //   askConsentToTrackInStorefront: boolean,
  //   wixExternalTrackingEnabled: boolean,
  //   openBagOnAddition: boolean,
  //   requirePhoneOnCheckout: boolean,
  //   askZipCode: boolean,
  //   showPricePerUnit: boolean,
  //   askTaxId: boolean,
  //   productCondition: string,
  //   recurringSubscriptionsSettings: {
  //     showRecurringSubscriptionsInControlPanel: boolean,
  //     supportedPaymentMethodsStatuses: {
  //       supportedPaymentMethodsAreAvailable: boolean,
  //       supportedPaymentMethodsAreConnected: boolean
  //     }
  //   }
  // };
  // mailNotifications: any;
  // company: {
  //   companyName: string,
  //   email: string,
  //   street: string,
  //   city: string,
  //   countryCode: string,
  //   postalCode: string,
  //   stateOrProvinceCode: string,
  //   phone: string
  // };
  // formatsAndUnits: {
  //   currency: string,
  //   currencyPrefix: string,
  //   currencySuffix: string,
  //   currencyGroupSeparator: string,
  //   currencyDecimalSeparator: string,
  //   currencyPrecision: number,
  //   currencyTruncateZeroFractional: boolean,
  //   currencyRate: number,
  //   weightUnit: string,
  //   weightGroupSeparator: string,
  //   weightDecimalSeparator: string,
  //   weightTruncateZeroFractional: boolean,
  //   timeFormat: string,
  //   dateFormat: string,
  //   timezone: string,
  //   dimensionsUnit: string,
  //   orderNumberPrefix: string,
  //   orderNumberSuffix: string,
  //   addressFormat: any
  // };
  // languages: any;
  // shipping: any;
  // zones: any[];
  // taxes: any[];
  // taxSettings: any;
  // payment: any;
  // featureToggles: any[];
  // legalPagesSettings: any;
  // designSettings: any;
  // productFiltersSettings: any;
  // orderInvoiceSettings: any;
  // socialLinksSettings: any;
  // tipsSettings: any;
  // taxInvoiceSettings: any;
  
}

export interface IUpdateFormProfileStore {
  address: string;
  city: string;
  closed: boolean;
  companyEmail: string;
  companyName: string;
  country: string;
  image: string;
  nueva: number;
  name: string;
  phone: string;
  postalCode: string;
  state: string;
  stateCode: string;
}


